import { render, staticRenderFns } from "./OfficesSettings.vue?vue&type=template&id=243a0c40&"
import script from "./OfficesSettings.vue?vue&type=script&lang=ts&"
export * from "./OfficesSettings.vue?vue&type=script&lang=ts&"
import style0 from "./OfficesSettings.vue?vue&type=style&index=0&id=243a0c40&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports